import React, { useRef, useEffect, useState } from 'react';
import {
  FloatingMenuPositionWrapper,
  FloatingMenuWrapper,
  MenuItemList,
  MenuItem
} from '../baseComponents';

function getPos(selectionCoords, floatingMenuEl, boundingEl) {
  const box = boundingEl.getBoundingClientRect();
  const el = floatingMenuEl.getBoundingClientRect();

  const pageLeft = selectionCoords.end.left;
  const absLeft = pageLeft - box.left;
  const absLeftWithinBounds = pageLeft + el.width > box.right ? absLeft - el.width : absLeft;
  const pageBottom = selectionCoords.end.bottom;
  const absBottom = box.bottom - pageBottom - el.height;
  const absBottomPaddedWithinBounds =
    pageBottom + el.height + 4 > box.bottom ? absBottom + el.height + 20 : absBottom - 4;

  return { bottom: Math.round(absBottomPaddedWithinBounds), left: Math.round(absLeftWithinBounds) };
}

function FloatingMenu(props) {
  const floatingMenuElRef = useRef();
  const [coords, setCoords] = useState({});

  useEffect(() => {
    if (floatingMenuElRef.current) {
      setCoords(getPos(props.pluginState.coords, floatingMenuElRef.current, props.boundingEl));
    }
  }, [floatingMenuElRef.current, props.pluginState.coords]);

  const statusCheck = cmdItem => {
    if (!cmdItem.isEnabled) return 'enabled';
    return cmdItem.isEnabled() ? 'enabled' : 'disabled';
  };

  return (
    <FloatingMenuPositionWrapper
      id="editor-ui-floating-menu"
      bottom={coords.bottom}
      left={coords.left}
    >
      <FloatingMenuWrapper ref={floatingMenuElRef}>
        <MenuItemList>
          {props.pluginState.activeItem.editCommands.map(cmdItem => (
            <MenuItem
              {...cmdItem}
              key={cmdItem.name}
              onClick={cmdItem.command}
              status={statusCheck(cmdItem)}
              size="small"
            />
          ))}
        </MenuItemList>
      </FloatingMenuWrapper>
    </FloatingMenuPositionWrapper>
  );
}

export default FloatingMenu;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/menus/floatingMenu/index.jsx